import { render } from "./Skins.vue?vue&type=template&id=5e8104e9"
import script from "./Skins.vue?vue&type=script&lang=js"
export * from "./Skins.vue?vue&type=script&lang=js"
script.render = render

export default script